/* eslint-disable
    @typescript-eslint/no-explicit-any,
    react/prefer-stateless-function
*/
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import React from 'react';

import EnzymeActivityTable from './EnzymeActivityTable';
import EnzymeProviderSelector from './EnzymeProviderSelector';

export interface EnzymeActivityTableWithProviderSelectorProps {
  enzymes?: any;
  provider: any;
  onChangeProvider: (...args: Array<any>) => any;
  providers?: any;
  small: boolean;
  pullSelectorRight: boolean;
}

class EnzymeActivityTableWithProviderSelector extends React.Component<EnzymeActivityTableWithProviderSelectorProps> {
  static defaultProps = {
    pullSelectorRight: false,
  };

  override render(): JSX.Element {
    return (
      <div className="u-tiny-spacing-top u-small-text">
        <div className={classNames({'pull-right': this.props.pullSelectorRight})}>
          <EnzymeProviderSelector
            providers={this.props.providers}
            value={this.props.provider}
            onChange={this.props.onChangeProvider}
            small={this.props.small}
            inline={true}
          />
        </div>
        <EnzymeActivityTable
          enzymes={this.props.enzymes}
          provider={this.props.provider}
          small={this.props.small}
        />
      </div>
    );
  }
}

export default EnzymeActivityTableWithProviderSelector;
